export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/menu_design.8a33afb.svg";